<template>
    <div style="max-width: 100%;">
        <b-card
            :title="`${user.name} (Ваш ID: ${user.id})`"
            :sub-title="user.position"
        >
            <b-card-text>
                <div class="row">
                    <div class="col-md-12">
                        <!-- Блок текущих условий сотрудничества -->
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="profile_info_block cooperation-conditions">
                                    <div class="profile_info_header_wrap position-relative text-center">
                                        <span class="profile_info_header text-brown cooperation-title">
                                            Текущие условия сотрудничества
                                        </span>
                                    </div>
                                    <div class="cooperation-conditions-content mt-3">
                                        <!-- Десктопная версия (колонки) -->
                                        <div class="row d-none d-md-flex">
                                            <div class="col-md-4">
                                                <div class="condition-item">
                                                    <div class="condition-icon">
                                                        <b-icon icon="star-fill"></b-icon>
                                                    </div>
                                                    <div class="condition-text">
                                                        <div class="condition-percentage">30%</div>
                                                        <div class="condition-description">от маржинальной прибыли с первой поставки</div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4">
                                                <div class="condition-item">
                                                    <div class="condition-icon">
                                                        <b-icon icon="calendar-check"></b-icon>
                                                    </div>
                                                    <div class="condition-text">
                                                        <div class="condition-percentage">25%</div>
                                                        <div class="condition-description">от маржинальной прибыли в течение первого года</div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4">
                                                <div class="condition-item">
                                                    <div class="condition-icon">
                                                        <b-icon icon="award"></b-icon>
                                                    </div>
                                                    <div class="condition-text">
                                                        <div class="condition-percentage">20%</div>
                                                        <div class="condition-description">от маржинальной прибыли до конца сотрудничества после первого года</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- Мобильная версия (горизонтальная прокрутка) -->
                                        <div class="conditions-scroll-container d-flex d-md-none">
                                            <div class="condition-item">
                                                <div class="condition-icon">
                                                    <b-icon icon="star-fill"></b-icon>
                                                </div>
                                                <div class="condition-text">
                                                    <div class="condition-percentage">30%</div>
                                                    <div class="condition-description">от маржинальной прибыли с первой поставки</div>
                                                </div>
                                            </div>
                                            
                                            <div class="condition-item">
                                                <div class="condition-icon">
                                                    <b-icon icon="calendar-check"></b-icon>
                                                </div>
                                                <div class="condition-text">
                                                    <div class="condition-percentage">25%</div>
                                                    <div class="condition-description">от маржинальной прибыли в течение первого года</div>
                                                </div>
                                            </div>
                                            
                                            <div class="condition-item">
                                                <div class="condition-icon">
                                                    <b-icon icon="award"></b-icon>
                                                </div>
                                                <div class="condition-text">
                                                    <div class="condition-percentage">20%</div>
                                                    <div class="condition-description">от маржинальной прибыли до конца сотрудничества после первого года</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Блок профиля -->
                        <div class="row mt-4">
                            <div :class="agentCompany && agentCompany.check_status === 'approved' ? 'col-md-6' : 'col-md-12'">
                                <div class="profile_info_block">
                                    <div class="profile_info_header_wrap position-relative">
                                         <span class="profile_info_header text-brown">Ваш профиль</span>
                   
                                         <div class="d-flex gap-2 edit-button">
                                             <b-button 
                                                 @click="showPasswordChange = !showPasswordChange"
                                                 v-if="!editMode && !isContractTerminated"
                                                 variant="outline-secondary"
                                                 size="sm"
                                             >
                                                <span class="d-none d-md-block">Сменить пароль</span>
                                                <span class="d-block d-md-none"><i class="fas fa-key"></i></span>
                                            </b-button>
                                             
                                             <b-button 
                                                 v-if="!editMode && !isContractTerminated"
                                                 @click="toggleEditMode"
                                                 class="ml-2"
                                             >
                                                <span class="d-none d-md-block">Редактировать</span>
                                                <span class="d-block d-md-none"><i class="fas fa-edit"></i></span>
                                             </b-button>
                                         </div>
                                         <div v-if="isContractTerminated" class="edit-button">
                                             <b-badge variant="warning">Заблокировано</b-badge>
                                         </div>
                                     </div>
                                                                         <!-- Предупреждение о блокировке редактирования -->
                                     <div v-if="isContractTerminated" class="mt-3">
                                         <b-alert 
                                             variant="warning" 
                                             show
                                         >
                                             <strong>🔒 Редактирование заблокировано</strong><br>
                                             Изменение данных профиля недоступно в связи с расторжением договора.
                                         </b-alert>
                                     </div>
                                     
                                     <div
                                         v-if="!editMode"
                                         class="profile_info mt-3"
                                     >
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Ваше ФИО:
                                            </div>
                                            <div>
                                                <div>{{ user.name }}</div>
                                            </div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Телефон:
                                            </div>
                                            <div>
                                                <div>{{ formattedPhone }}</div>
                                            </div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Почта:
                                            </div>
                                            <div>{{ user.email }}</div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Опыт в логистике:
                                            </div>
                                            <div>
                                                <b-badge :variant="user.is_logistics_beginner ? 'warning' : 'success'">
                                                    {{ user.is_logistics_beginner ? 'Новичок' : 'Опытный' }}
                                                </b-badge>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="editMode && !isContractTerminated"
                                        class="profile_info mt-3"
                                    >
                                        <div class="d-flex profile_info_label mt-2">
                                            <div class="label">
                                                Ваше ФИО:
                                            </div>
                                            <b-form-input
                                                v-model="user.name"
                                                size="sm"
                                                required
                                                class="form-control"
                                            />
                                        </div>
                                        <div class="d-flex profile_info_label mt-2">
                                            <div class="label">
                                                Телефон:
                                            </div>
                                            <b-form-input
                                                v-model="user.phone"
                                                v-mask="`+# (###) ###-##-##`"
                                                size="sm"
                                                required
                                                class="form-control"
                                            />
                                        </div>
                                        <div class="d-flex profile_info_label mt-2">
                                            <div class="label">
                                                Почта:
                                            </div>
                                            <b-form-input
                                                v-model="user.email"
                                                disabled
                                                title="Может быть отредактирован только администратором"
                                                size="sm"
                                                type="email"
                                                required
                                                class="form-control"
                                            />
                                        </div>
                                        <div class="d-flex profile_info_label mt-2">
                                            <div class="label">
                                                Опыт в логистике:
                                            </div>
                                            <b-form-radio-group
                                                v-model="user.is_logistics_beginner"
                                                :options="logisticsExperienceOptions"
                                                size="sm"
                                                class="form-control"
                                            />
                                        </div>
                                        <div class="mt-2 text-right">
                                            <b-button 
                                              @click="toggleEditMode"
                                              v-if="editMode && !savingProcess"
                                              class="mr-2"
                                            >Отменить</b-button>   
                          
                                            <b-button
                                              @click="saveUserSettings" 
                                              class="btn btn-primary"
                                              :disabled="savingProcess"
                                            >Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></b-button >
                                          </div>                          
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="agentCompany && agentCompany.check_status === 'approved'">
                                <!-- Корпоративная почта -->
                                <div class="profile_info_block">
                                    <div class="profile_info_header_wrap position-relative">
                                        <span class="profile_info_header text-brown">
                                            <b-icon icon="envelope" class="mr-2"></b-icon>
                                            Корпоративная почта
                                        </span>
                                    </div>
                                    <div class="profile_info mt-3">
                                        <!-- Если есть корпоративная почта -->
                                        <AgentCorpMail v-if="hasCorpMail" :corpMailData="corpMailData" />
                                        
                                        <!-- Если нет корпоративной почты -->
                                        <div v-else class="corp-mail-placeholder">
                                            <div class="alert alert-info">
                                                <div class="d-flex align-items-center">
                                                    <b-icon icon="info-circle" class="mr-2"></b-icon>
                                                    <div>
                                                        <strong>Ваша корпоративная почта еще не готова.</strong><br>
                                                        Если ее слишком долго нет, напишите нам в поддержку, нажав на иконку в правом верхнем углу.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Форма смены пароля -->
                        <div class="row mt-4" v-if="showPasswordChange">
                            <div class="col-md-12">
                                <div class="profile_info_block">
                                    <div class="profile_info_header_wrap position-relative">
                                        <span class="profile_info_header text-brown">Смена пароля</span>
                                    </div>
                                    <div class="profile_info mt-3">
                                        <PasswordChangeForm @cancel="showPasswordChange = false" />
                                    </div>
                                </div>
                            </div>
                        </div>                        

                        <!-- Агентская компания -->
                        <div class="row mt-4" v-if="agentCompany">
                            <div class="col-md-12">
                                <div class="profile_info_block">
                                    <div class="profile_info_header_wrap position-relative">
                                         <span class="profile_info_header text-brown">Данные агентской компании</span>
                                         
                                         <b-button 
                                             v-if="!editCompanyMode && !isContractTerminated"
                                             class="edit-button"
                                             @click="toggleEditCompanyMode"
                                         >
                                                <span class="d-none d-md-block">Редактировать</span>
                                                <span class="d-block d-md-none"><i class="fas fa-edit"></i></span>
                                         </b-button>
                                         <div v-if="isContractTerminated" class="edit-button">
                                             <b-badge variant="warning">Заблокировано</b-badge>
                                         </div>
                                     </div>

                                    <!-- Статус проверки -->
                                     <div class="mt-3">
                                         <b-alert 
                                             v-if="agentCompany.check_status === 'approved'"
                                             variant="success" 
                                             show
                                         >
                                             ✅ Подписан договор оферты
                                         </b-alert>
                                         <b-alert 
                                             v-else-if="agentCompany.check_status === 'approved_by_company'"
                                             variant="success" 
                                             show
                                         >
                                             ✅ Ваша анкета проверена
                                         </b-alert>
                                         <b-alert 
                                             v-else-if="agentCompany.check_status === 'pending'"
                                             variant="info" 
                                             show
                                         >
                                             ⏳ Ваша агентская компания находится на проверке
                                         </b-alert>
                                         <b-alert 
                                             v-else-if="agentCompany.check_status === 'revision'"
                                             variant="warning" 
                                             show
                                         >
                                             ⚠️ Ваша агентская компания требует доработки
                                         </b-alert>
                                         <b-alert 
                                             v-else-if="agentCompany.check_status === 'rejected'"
                                             variant="danger" 
                                             show
                                         >
                                             ❌ Ваша агентская компания отклонена
                                         </b-alert>
                                         <b-alert 
                                             v-else-if="agentCompany.check_status === 'termination_by_agent'"
                                             variant="warning" 
                                             show
                                         >
                                             🔒 Редактирование заблокировано - вы расторгли договор
                                         </b-alert>
                                         <b-alert 
                                             v-else-if="agentCompany.check_status === 'termination_by_company'"
                                             variant="danger" 
                                             show
                                         >
                                             🔒 Редактирование заблокировано - договор расторгнут компанией
                                         </b-alert>
                                     </div>

                                    <!-- Предупреждение о верификации -->
                                    <div v-if="editCompanyMode && agentCompany.check_status === 'approved'" class="mt-3">
                                        <b-alert 
                                            variant="warning" 
                                            show
                                        >
                                            <strong>⚠️ Внимание!</strong><br>
                                            При изменении данных вашей агентской компании, она автоматически отправится на повторную верификацию. 
                                            На время проверки ваша деятельность будет заблокирована.
                                        </b-alert>
                                    </div>

                                    <!-- Просмотр данных -->
                                    <div
                                        v-if="!editCompanyMode"
                                        class="profile_info mt-3"
                                    >
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Название компании:
                                            </div>
                                            <div>{{ agentCompany.full_name }}</div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Тип:
                                            </div>
                                            <div>{{ agentCompany.type === 'ip' ? 'Индивидуальный предприниматель' : 'Физическое лицо' }}</div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                ИНН:
                                            </div>
                                            <div>{{ agentCompany.inn }}</div>
                                        </div>
                                        <div class="d-flex profile_info_label" v-if="agentCompany.ogrnip">
                                            <div class="label">
                                                ОГРНИП:
                                            </div>
                                            <div>{{ agentCompany.ogrnip }}</div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Адрес регистрации:
                                            </div>
                                            <div>{{ agentCompany.registration_address }}</div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Фактический адрес:
                                            </div>
                                            <div>{{ agentCompany.address }}</div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Банк:
                                            </div>
                                            <div>{{ agentCompany.bank_name }}</div>
                                        </div>
                                        <div class="d-flex profile_info_label">
                                            <div class="label">
                                                Расчётный счёт:
                                            </div>
                                            <div>{{ agentCompany.bank_account }}</div>
                                        </div>
                                    </div>

                                    <!-- Редактирование данных -->
                                    <div v-if="editCompanyMode && !isContractTerminated" class="mt-3">
                                        <AgentCompanyProfile 
                                            :agent_company="agentCompany"
                                            :hideSaveButton="true"
                                            @updated="onCompanyUpdated"
                                            @closed="toggleEditCompanyMode"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <!-- Блок расторжения договора -->
                        <div class="row mt-4" v-if="agentCompany && agentCompany.check_status === 'approved'">
                            <div class="col-md-12">
                                <div class="profile_info_block">
                                    <div class="profile_info_header_wrap position-relative">
                                        <span class="profile_info_header text-brown">Расторжение договора</span>
                                    </div>
                                    <div class="profile_info mt-3">
                                        <div class="alert alert-info">
                                            <p class="mb-3">
                                                <strong>Уважаемый агент!</strong>
                                            </p>
                                            <p class="mb-3">
                                                Вы можете в любое время прекратить свою деятельность в качестве агента нашей компании. 
                                                Для этого нажмите кнопку "Расторгнуть договор" ниже.
                                            </p>
                                            <p class="mb-3">
                                                После подачи заявки на расторжение договора:
                                            </p>
                                            <ul class="easy-list">
                                                <li>Ваша деятельность в качестве агента будет приостановлена.</li>
                                                <li>Наши специалисты свяжутся с вами в случае необходимости.</li>
                                                <li>Все невыполненные обязательства должны будут урегулированы в рабочем порядке.</li>
                                            </ul>
                                            <p class="mb-0">
                                                <strong>Внимание:</strong> Это действие необратимо. Пожалуйста, убедитесь, что вы действительно хотите расторгнуть договор.
                                            </p>
                                        </div>
                                        <div class="text-center">
                                            <b-button
                                                variant="danger"
                                                size="lg"
                                                @click="showTerminationModal = true"
                                                :disabled="terminationLoading"
                                            >
                                                <b-icon icon="exclamation-triangle" class="mr-2"></b-icon>
                                                Расторгнуть договор
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Статус расторжения договора -->
                        <div class="row mt-4" v-if="agentCompany && agentCompany.check_status === 'termination_by_agent'">
                            <div class="col-md-12">
                                <div class="profile_info_block">
                                    <div class="profile_info_header_wrap position-relative">
                                        <span class="profile_info_header text-brown">Статус расторжения договора</span>
                                    </div>
                                    <div class="profile_info mt-3">
                                        <div class="alert alert-warning">
                                            <p class="mb-2">
                                                <strong>Вы решили расторгнуть договор</strong>
                                            </p>
                                            <p class="mb-2">
                                                Дата подачи заявки: {{ agentCompany.contract_terminated_at }}
                                            </p>
                                            <p class="mb-2" v-if="agentCompany.comment_on_termination">
                                                <strong>Причина расторжения:</strong> {{ agentCompany.comment_on_termination }}
                                            </p>
                                            <p class="mb-0">
                                                В случае возникновения дополнительных вопросов, наши специалисты свяжутся с вами в ближайшее время.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-md-12">
                                <div class="profile_info_block">
                                    <div class="profile_info">
                                        <div class="profile_info_label">
                                            <div class="label mt-2">
                                                <b-button
                                                    variant="outline-secondary"
                                                    :class="historyOfLogins ? null : 'collapsed'"
                                                    :aria-expanded="historyOfLogins ? 'true' : 'false'"
                                                    aria-controls="collapse-historyOfLogins"
                                                    @click="historyOfLogins = !historyOfLogins"
                                                >
                                                    <span v-if="!historyOfLogins">Открыть историю входов</span>
                                                    <span v-if="historyOfLogins">Закрыть историю входов</span>
                                                </b-button>   
                                                <b-button
                                                    v-if="historyOfLogins"
                                                    variant="secondary"
                                                    @click="getUserLogins()"
                                                >
                                                    <b-icon
                                                        icon="arrow-repeat"
                                                        scale="1"
                                                        aria-label="Reload"
                                                        :animation="loading_user_logins ? 'spin' : ''"
                                                    />
                                                </b-button>                                 
                                            </div>
                                            <b-collapse
                                                id="collapse-historyOfLogins"
                                                v-model="historyOfLogins"
                                                class="mt-2"
                                            >
                                                <b-card>
                                                    <div>
                                                        <ul>
                                                            <li
                                                                v-for="login in user_logins"
                                                                :key="login.login_at"
                                                            >
                                                                {{ login.login_at }} {{ login.ip }} {{ login.browser }}
                                                            </li>
                                                        </ul>
                                                    </div>                    
                                                </b-card>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card-text>
        </b-card>

        <!-- Модальное окно подтверждения расторжения договора -->
        <b-modal
            v-model="showTerminationModal"
            title="Подтверждение расторжения договора"
            size="lg"
            centered
        >
            <div class="text-center">
                <b-icon 
                    icon="exclamation-triangle-fill" 
                    variant="danger" 
                    font-scale="3"
                    class="mb-3"
                ></b-icon>
                
                <h5 class="mb-3">Вы уверены, что хотите расторгнуть договор?</h5>
                
                <div class="alert alert-warning text-left">
                    <p class="mb-2"><strong>Последствия расторжения договора:</strong></p>
                    <ul class="easy-list">
                        <li>Ваша деятельность в качестве агента будет немедленно приостановлена.</li>
                        <li>Вы не сможете создавать новые заказы.</li>
                        <li>Все активные заказы будут переданы нашим менеджерам.</li>
                        <li>Процедура расторжения займет некоторое время.</li>
                    </ul>
                </div>
                
                <!-- Выбор причины расторжения -->
                <div class="text-left mt-4">
                    <h6 class="mb-3">Пожалуйста, укажите причину расторжения договора:</h6>
                    
                    <b-form-group>
                        <b-form-radio-group
                            v-model="selectedTerminationReason"
                            :options="terminationReasons"
                            stacked
                            name="termination-reason"
                        ></b-form-radio-group>
                    </b-form-group>
                    
                    <!-- Поле для свободной формы -->
                    <div v-if="selectedTerminationReason === 'other'" class="mt-3">
                        <b-form-group label="Укажите свою причину:">
                            <b-form-textarea
                                v-model="customTerminationReason"
                                placeholder="Опишите причину расторжения договора..."
                                rows="3"
                                max-rows="6"
                                :state="customTerminationReasonState"
                            ></b-form-textarea>
                            <b-form-invalid-feedback>
                                Пожалуйста, укажите причину расторжения
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                </div>
                
                <p class="text-muted mt-3">
                    Это действие необратимо. После подтверждения вы не сможете отменить расторжение договора.
                </p>
            </div>
            
            <template #modal-footer>
                <div class="w-100 d-flex justify-content-between">
                    <b-button
                        variant="danger"
                        style="text-transform: uppercase; height: 40px;"
                        @click="terminateContract"
                        :disabled="terminationLoading || !canTerminate"
                    >
                        <b-spinner small v-if="terminationLoading"></b-spinner>
                        {{ terminationLoading ? 'Отправка...' : 'Да, подтверждаю' }}
                    </b-button>                    
                    <b-button
                        variant="success"
                        style="text-transform: uppercase; height: 40px;"
                        @click="showTerminationModal = false"
                        :disabled="terminationLoading"
                    >
                        Нет, остаюсь с вами
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import {
        defaultDataItems,
    } from '@/mixins';
        
    import { USER_LOGINS, API_USERS, API_AGENT_COMPANY } from '../constants';
    import { mapGetters } from 'vuex';
    import AgentCompanyProfile from '@/components/agentCompanies/AgentCompanyProfile.vue';
    import AgentCorpMail from '@/components/agent/AgentCorpMail.vue';
    import PasswordChangeForm from '@/components/common/PasswordChangeForm.vue';
        
    export default {
        components: {
            AgentCompanyProfile,
            AgentCorpMail,
            PasswordChangeForm
        },
        mixins: [
            defaultDataItems,
        ],  
        data: () => ({
            user_logins: [],
            loading_user_logins: false,
            editMode: false,
            editCompanyMode: false,
            loading: false,
            showPasswordChange: false,
            savingProcess: false,
            user: {},
            agentCompany: null,
            historyOfLogins: false,
            showTerminationModal: false,
            terminationLoading: false,
            corpMailData: null,
            corpMailLoading: false,
            selectedTerminationReason: null,
            customTerminationReason: '',
            terminationReasons: [
                { text: 'Не устраивают условия сотрудничества', value: 'conditions' },
                { text: 'Низкий уровень поддержки', value: 'support' },
                { text: 'Сложности с получением заказов', value: 'orders' },
                { text: 'Изменение личных обстоятельств', value: 'personal' },
                { text: 'Нашел другую работу/возможности', value: 'other_work' },
                { text: 'Другая причина', value: 'other' }
            ],
            logisticsExperienceOptions: [
                { text: 'Новичок в логистике', value: true },
                { text: 'Имею опыт в логистике', value: false }
            ]
        }),
        
        watch: {
            currentUser: {
                handler(user) {
                    this.user = JSON.parse(JSON.stringify(user));
                },
                deep: true,
                immediate: true
            },
            
            agentCompany: {
                handler(newVal) {
                    // Загружаем корпоративную почту при изменении статуса агента
                    if (newVal && newVal.check_status === 'approved') {
                        this.loadCorpMail();
                    } else {
                        this.corpMailData = null;
                    }
                },
                deep: true,
                immediate: true
            },   
        },
        
                 computed: {
             ...mapGetters('auth', ['currentUser']),
             
             formattedPhone() {
                 if (!this.user.phone) return '';
                 return this.user.phone.startsWith('+') ? this.user.phone : `+${this.user.phone}`;
             },
             
             isContractTerminated() {
                 return this.agentCompany && (
                     this.agentCompany.check_status === 'termination_by_agent' || 
                     this.agentCompany.check_status === 'termination_by_company'
                 );
             },
             
             canTerminate() {
                 if (!this.selectedTerminationReason) {
                     return false;
                 }
                 
                 if (this.selectedTerminationReason === 'other') {
                     return this.customTerminationReason.trim().length > 0;
                 }
                 
                 return true;
             },
             
             customTerminationReasonState() {
                 if (this.selectedTerminationReason === 'other') {
                     return this.customTerminationReason.trim().length > 0 ? null : false;
                 }
                 return null;
             },
             
             hasCorpMail() {
                 return this.corpMailData !== null;
             },
         },
        
        mounted() {
            this.getUserLogins();
            this.loadAgentCompany();
            this.loadCorpMail();
        },
        
        methods: {
            toggleEditMode() {
                if (this.isContractTerminated) {
                    this.makeToast('warning', 'Редактирование заблокировано в связи с расторжением договора', 6000);
                    return;
                }
                this.editMode = !this.editMode;
            },

            toggleEditCompanyMode() {
                if (this.isContractTerminated) {
                    this.makeToast('warning', 'Редактирование заблокировано в связи с расторжением договора', 6000);
                    return;
                }
                this.editCompanyMode = !this.editCompanyMode;
            },

            onCompanyUpdated(updatedCompany) {
                // Обновляем данные агентской компании
                this.agentCompany = { ...this.agentCompany, ...updatedCompany };
                
                // Если статус изменился на revision, показываем предупреждение
                if (updatedCompany.check_status === 'revision') {
                    this.makeToast('warning', 'Ваша агентская компания отправлена на повторную верификацию. На время проверки деятельность будет заблокирована.', 10000);
                } else {
                    this.makeToast('success', 'Данные агентской компании успешно сохранены!', 6000);
                }
                
                this.editCompanyMode = false;
            },
        
            saveUserSettings() {
                if (this.isContractTerminated) {
                    this.makeToast('warning', 'Сохранение заблокировано в связи с расторжением договора', 6000);
                    return;
                }
                
                this.savingProcess = true;
        
                const user = {
                    email: this.user.email,
                    name: this.user.name,
                    position: this.user.position,
                    phone: this.user.phone,
                    is_logistics_beginner: this.user.is_logistics_beginner
                };
        
                api.call('put', `${API_USERS}/${this.currentUser.id}`, user)
                    .then((response) => {
                        // Update Vuex store with new user data
                        this.$store.commit('auth/USER_SUCCESS', response.data);
                        // Update localStorage with new user data
                        localStorage.setItem('user', JSON.stringify(response.data));
                        this.makeToast('success', 'Настройки профиля успешно сохранены!', 6000);
                        this.editMode = false;
                    })
                    .catch(error => {
                        console.error(error);
        
                        this.makeToast('danger', 'Проверьте указанные данные! Все поля должны быть заполнены.', 6000);
                    })
                    .finally(() => {
                        this.savingProcess = false;
                    });      
            },

            async loadAgentCompany() {
                try {
                    const response = await api.call('get', `${API_AGENT_COMPANY}/my`);
                    this.agentCompany = response.data;
                } catch (error) {
                    console.error('Ошибка загрузки агентской компании:', error);
                }
            },
        
            getUserLogins(){
                this.loading_user_logins = true;
        
                api
                    .call('get', USER_LOGINS)
                    .then(({data}) => this.user_logins = data)
                    .finally(() => this.loading_user_logins = false);
            },

            async terminateContract() {
                if (!this.canTerminate) {
                    this.makeToast('warning', 'Пожалуйста, выберите причину расторжения договора', 5000);
                    return;
                }
                
                this.terminationLoading = true;
                
                try {
                    // Формируем комментарий для отправки
                    let comment = '';
                    if (this.selectedTerminationReason === 'other') {
                        comment = this.customTerminationReason.trim();
                    } else {
                        const selectedReason = this.terminationReasons.find(r => r.value === this.selectedTerminationReason);
                        comment = selectedReason ? selectedReason.text : '';
                    }
                    
                    const response = await api.call('post', `${API_AGENT_COMPANY}/terminate-contract`, {
                        comment_on_termination: comment
                    });
                    
                    if (response.data.success) {
                        this.makeToast('success', 'Заявка на расторжение договора успешно отправлена!', 8000);
                        this.showTerminationModal = false;
                        
                        // Сбрасываем форму
                        this.selectedTerminationReason = null;
                        this.customTerminationReason = '';
                        
                        // Обновляем данные агентской компании локально
                        await this.loadAgentCompany();
                        
                        // Обновляем данные агентской компании в Vuex store
                        await this.$store.dispatch('auth/refreshAgentCompany');
                    }
                } catch (error) {
                    console.error('Ошибка при расторжении договора:', error);
                    
                    let errorMessage = 'Произошла ошибка при отправке заявки на расторжение договора';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    
                    this.makeToast('danger', errorMessage, 8000);
                } finally {
                    this.terminationLoading = false;
                }
            },
            
            async loadCorpMail() {
                // Загружаем корпоративную почту только если агент в статусе approved
                if (this.agentCompany && this.agentCompany.check_status === 'approved') {
                    this.corpMailLoading = true;
                    try {
                        const response = await api.call('get', '/api/agent-corp-mail/current');
                        
                        if (response.data.data) {
                            // Загружаем полные данные с паролем
                            const fullResponse = await api.call('get', '/api/agent-corp-mail/current/full');
                            this.corpMailData = fullResponse.data.data;
                        } else {
                            this.corpMailData = null;
                        }
                    } catch (error) {
                        console.error('Ошибка загрузки корпоративной почты:', error);
                        this.corpMailData = null;
                    } finally {
                        this.corpMailLoading = false;
                    }
                }
            },
        },
    };
</script>
    
<style scoped>
    .edit-button {
        position: absolute;
        top: 0;
        right: 0;
    }
    .custom-select {
        height: 35px !important;
        line-height: 15px;
        border-radius: 2px;
        margin-left: 2px;
        padding-left: 7px;
    }
    pre {
        line-height: 100%;
    }
    .email-sign {
        font-size: 14px;
        line-height: 21px;
        margin-bottom: 25px;
    }
    
    /* Стили для блока условий сотрудничества */
    .cooperation-conditions {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border: 2px solid #0d6348;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(13, 99, 72, 0.15);
        position: relative;
        overflow: hidden;
        margin-bottom: 30px;
    }
    
    .cooperation-conditions::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, #0d6348 0%, #e37926 100%);
    }
    
    .cooperation-conditions-content {
        padding: 20px;
    }
    
    /* Стили для десктопной версии (колонки) */
    .cooperation-conditions-content .row .col-md-4:not(:last-child) {
        padding-right: 10px;
    }
    
    .cooperation-conditions-content .row .col-md-4:not(:first-child) {
        padding-left: 10px;
    }
    
    /* Горизонтальная прокрутка только для мобильных */
    .conditions-scroll-container {
        gap: 20px;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 10px 0;
        scrollbar-width: thin;
        scrollbar-color: #0d6348 #f1f1f1;
    }
    
    .conditions-scroll-container::-webkit-scrollbar {
        height: 8px;
    }
    
    .conditions-scroll-container::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    
    .conditions-scroll-container::-webkit-scrollbar-thumb {
        background: #0d6348;
        border-radius: 4px;
    }
    
    .conditions-scroll-container::-webkit-scrollbar-thumb:hover {
        background: #0a4d38;
    }
    
    .cooperation-title {
        font-size: 24px !important;
        font-weight: 700 !important;
        color: #0d6348 !important;
        text-transform: uppercase;
        letter-spacing: 1px;
        text-shadow: 0 2px 4px rgba(13, 99, 72, 0.1);
        margin-bottom: 10px;
        display: inline-block;
        position: relative;
        padding-top: 30px;
        background: transparent;
    }
    
    .cooperation-title::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background: linear-gradient(90deg, #0d6348 0%, #e37926 100%);
        border-radius: 2px;
    }
    
    .condition-item {
        display: flex;
        align-items: center;
        padding: 20px;
        background: white;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        transition: all 0.3s ease;
        border-left: 4px solid #0d6348;
        position: relative;
        overflow: hidden;
        height: 120px; /* Фиксированная высота для всех блоков */
        min-height: 120px;
    }
    
    .condition-item::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        background: linear-gradient(180deg, #0d6348 0%, #e37926 100%);
        transform: scaleY(0);
        transition: transform 0.3s ease;
    }
    
    .condition-item:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(13, 99, 72, 0.2);
    }
    
    .condition-item:hover::before {
        transform: scaleY(1);
    }
    
    .condition-icon {
        flex-shrink: 0;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #0d6348 0%, #0a4d38 100%);
        border-radius: 50%;
        margin-right: 20px;
        box-shadow: 0 4px 12px rgba(13, 99, 72, 0.3);
        transition: all 0.3s ease;
    }
    
    .condition-item:hover .condition-icon {
        background: linear-gradient(135deg, #e37926 0%, #d66a1a 100%);
        transform: scale(1.1);
    }
    
    .condition-icon .b-icon {
        color: white !important;
        font-size: 1.2rem;
        filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
    }
    
    .condition-text {
        flex: 1;
    }
    
    .condition-percentage {
        font-size: 28px;
        font-weight: bold;
        color: #0d6348;
        line-height: 1;
        margin-bottom: 8px;
        text-shadow: 0 1px 2px rgba(0,0,0,0.1);
        position: relative;
    }
    
    .condition-percentage::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, #0d6348 0%, transparent 100%);
        border-radius: 1px;
    }
    
    .condition-description {
        font-size: 14px;
        color: #495057;
        line-height: 1.4;
        font-weight: 500;
        opacity: 0.9;
        transition: opacity 0.3s ease;
    }
    
    .condition-item:hover .condition-description {
        opacity: 1;
    }
    
    /* Адаптивность для мобильных устройств */
    @media (max-width: 768px) {
        .cooperation-conditions {
            margin-top: 0px;
            padding-bottom: 5px;
        }
        
        .cooperation-conditions-content {
            padding: 0px 15px 15px 15px;
        }
        
        .conditions-scroll-container {
            gap: 15px;
            padding: 5px 0 20px 0;
        }
        
        .conditions-scroll-container .condition-item {
            flex: 0 0 250px; /* Уменьшенная ширина на мобильных */
            min-width: 250px;
        }
        
        .cooperation-title {
            font-size: 17px !important;
            letter-spacing: 0.5px;
        }
        
        .condition-item {
            padding: 60px 15px;
            height: 100px;
            min-height: 100px;
        }
        
        .condition-icon {
            width: 40px;
            height: 40px;
            margin-right: 15px;
        }
        
        .condition-percentage {
            font-size: 24px;
        }
        
        .condition-description {
            font-size: 13px;
        }
    }
    
    /* Стили для блока корпоративной почты */
    .corp-mail-placeholder .alert {
        border: none;
        border-radius: 12px;
        background: linear-gradient(135deg, #f0f9f5 0%, #e8f5e8 100%);
        color: #0d6348;
        border-left: 4px solid #0d6348;
        box-shadow: 0 2px 8px rgba(13, 99, 72, 0.1);
        position: relative;
        overflow: hidden;
    }
    
    .corp-mail-placeholder .alert::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 60px;
        height: 60px;
        background: linear-gradient(135deg, #e37926 0%, #d66a1a 100%);
        border-radius: 50%;
        transform: translate(30px, -30px);
        opacity: 0.1;
    }
    
    .corp-mail-placeholder .alert strong {
        color: #0d6348;
        font-weight: 600;
    }
    
    .corp-mail-placeholder .b-icon {
        color: #e37926;
        font-size: 1.2rem;
    }
    
    .corp-mail-placeholder .alert .d-flex {
        position: relative;
        z-index: 1;
    }
    
    /* Стили для блоков профиля */
    .profile_info_label {
        margin-bottom: 8px;
        padding: 6px 0;
        border-bottom: 1px solid #e9ecef;
    }
    
    .profile_info_label:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }
    
    .profile_info_label .label {
        font-weight: 600;
        color: #495057;
        margin-bottom: 3px;
        font-size: 14px;
    }
    
    .profile_info_label > div:not(.label) {
        color: #212529;
        font-size: 15px;
        line-height: 1.3;
    }
    
    /* Мобильная адаптация для блоков профиля */
    @media (max-width: 768px) {
        .profile_info_label {
            flex-direction: column !important;
            align-items: flex-start !important;
            padding: 8px 0;
            margin-bottom: 6px;
        }
        
        .profile_info_label .label {
            margin-bottom: 4px;
            font-size: 13px;
            color: #6c757d;
            font-weight: 500;
        }
        
        .profile_info_label > div:not(.label) {
            font-size: 14px;
            width: 100%;
            word-break: break-word;
            line-height: 1.3;
        }
        
        /* Специальные стили для полей ввода в режиме редактирования */
        .profile_info_label .form-control {
            margin-top: 3px;
            width: 100% !important;
        }
    }
    
    /* Дополнительная адаптация для очень маленьких экранов */
    @media (max-width: 480px) {
        .profile_info_label {
            padding: 6px 0;
            margin-bottom: 5px;
        }
        
        .profile_info_label .label {
            font-size: 12px;
            margin-bottom: 3px;
        }
        
        .profile_info_label > div:not(.label) {
            font-size: 13px;
        }
    }
</style>